export default __webpack_public_path__ + "static/summer_containers82-6975f0f1a2010b32c06af8ce7452bf54.webp";